export default __webpack_public_path__ + "staticlp3/media/istoe.572e31dd.jpg";